import { Typography } from '@mui/material';
import { EDashboardWidgetTypes, type IDashboardWidgetProps } from '@sharedInterfaces/IDashboard';
import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import OnboardingCardWidget from '@src/App/Components/Widgets/OnboardingCardWidget';
import type { TWidgetDefinition } from '@src/App/Pages/DashboardPage/Dashboard/Dashboard';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';

const OnboardingDashboardWidget: React.FC<IDashboardWidgetProps<EDashboardWidgetTypes.onboardingWidget>> = ({
    id,
    params,
    isEditing,
    onParamChange,
}) => {
    const lang = useSelector((state: AppState) => state.employee.language);
    const langStrings = getLanguageTexts(lang).dashboard;

    if (isEditing)
        return (
            <>
                <Typography>{langStrings.noSettings}</Typography>
            </>
        );

    return <OnboardingCardWidget />;
};

export const onboardingDashboardWidgetDefinition = {
    type: EDashboardWidgetTypes.onboardingWidget,
    render: OnboardingDashboardWidget,
    overrideCardDesign: true,
    defaultParams: {},
} satisfies TWidgetDefinition;
